import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { InputValidators } from '../../../../utils/InputValidators';
import { FiAlertTriangle, FiSave, FiSlash } from 'react-icons/fi';
import { newDevice } from '../../../store/Thunk';
import Swal from 'sweetalert2';

export const M_NewDevice = ({ onClose, closeOnEscape = true, closeOnBackdrop = true }) => {


    // ============ [ GESTION DE MODAL ] ============ //
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);

    useEffect(() => {
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    // Cerrar con Escape si está permitido
    useEffect(() => {
        if (!closeOnEscape) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") handleClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [closeOnEscape]);

    // Cerrar con clic fuera si está permitido
    const handleBackdropClick = (e) => {
        if (!closeOnBackdrop) return;
        if (dialogRef.current && !dialogRef.current.contains(e.target)) {
            handleClose();
        }
    };

    // Animación al cerrar
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 250); // espera la animación
    };

    //========================================================================================================

    const dispatch = useDispatch();



    const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm();
    const { idCustomer } = useSelector(state => state.customerDetail);
    const { marcas, categorias } = useSelector(state => state.catalogos);
    const { id_emp } = useSelector(state => state.usuario);


    const idUser = id_emp;


    const descripcionCount = watch("descriptionDevice") || "";


    const save = (data) => {
        console.log("Datos guardados:", data);
        Swal.fire({
            title: 'Atención',
            text: "Está por registrar un Nuevo dispositivo, ¿Desea de continuar con esta acción?",
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                // dispatch(activateProduct(id));
                //       // console.log(data);
                dispatch(newDevice(data, idUser, idCustomer));
                onClose(); // cerrar modal al guardar
                reset();
            }
        })
    };

    return (
        <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
            <div ref={dialogRef} className={`modal-dialog custom-modal-animate ${isVisible ? "show" : ""}`}>
                <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">Nuevo dispostivo</h5>
                        <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
                    </div>
                    <form onSubmit={handleSubmit(save)}>
                        <div className="modal-body container">

                            <div className='row'>

                                <div className="col-6 mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Categoria:</label>
                                    <select className={`form-select ${errors.categoryID ? 'is-invalid' : ''}`}  {...register("categoryID", { required: 'Categoria, requerido' })}>
                                        <option value="" >Seleccione categoria</option>
                                        {
                                            categorias.map((item, index) => (
                                                <option key={index} value={item.ID} className='text-uppercase' >{item.NOMBRE}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.categoryID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.categoryID.message}</small></span>
                                        </div>
                                    }
                                </div>

                                <div className="col-6 mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Marca:</label>
                                    <select className={`form-select ${errors.brandID ? 'is-invalid' : ''}`}  {...register("brandID", { required: 'Marca, requerido' })} >
                                        <option value="" >Seleccione marca</option>
                                        {
                                            marcas.map((item, index) => (
                                                <option key={index} value={item.ID} className='text-uppercase' >{item.NOMBRE}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.brandID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.brandID.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>


                            <div className='row'>
                                <div className="col-6 mb-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>Modelo:</label>
                                    <input type="text" className="form-control w-100" autoComplete='off'
                                        {...register("modelDevice", { required: 'Modelo del equipo es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                                        onKeyDown={InputValidators.validateAlphanumeric} />
                                    {errors.modelDevice && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="20" /> <small>{errors.modelDevice.message}</small>
                                        </div>
                                    )}
                                </div>

                                <div className="col-6 mb-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>Sistema Operativo:</label>
                                    <input type="text" className="form-control" autoComplete='off'
                                        {...register("systemOperative", { required: 'Sistema Operativo del equipo es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                                        onKeyDown={InputValidators.validateAlphanumeric} />
                                    {errors.systemOperative && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="22" /> <small>{errors.systemOperative.message}</small>
                                        </div>
                                    )}
                                </div>
                            </div>



                            <div className="mb-2">
                                <label className="form-label"><span className="text-danger fw-bold">*</span>No. de serie:</label>
                                <input type="text" className="form-control" autoComplete='off'
                                    {...register("noSerie", { required: 'Serie del equipo es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                                    onKeyDown={InputValidators.validateAlphanumeric} />
                                {errors.noSerie && (
                                    <div className='text-danger fw-bold mt-1'>
                                        <FiAlertTriangle size="22" /> <small>{errors.noSerie.message}</small>
                                    </div>
                                )}
                            </div>

                            {/* <div className="mb-1">
                                <label className="form-label">Descripcion <span className='small'>(250 Caracteres max)</span>:</label>
                                <textarea rows="5" className={`form-control ${errors.descriptionDevice ? 'is-invalid' : ''}`} maxLength={250}
                                    {...register("descriptionDevice", {

                                        maxLength: { value: 250, message: 'Observaciones del equipo No debe tener mas de 250 caracteres' }
                                    })}
                                    onKeyDown={InputValidators.validateAlphanumeric}
                                ></textarea>
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    {
                                        errors.descriptionDevice ? (
                                            <div className="text-danger d-flex align-items-center">
                                                <FiAlertTriangle size={18} className="me-1" />
                                                <small className="fw-bold">{errors.descriptionDevice.message}</small>
                                            </div>
                                        ) : (<div></div>)
                                    }
                                    <small className="text-muted">{descripcionCount.length}/250</small>
                                </div>
                            </div> */}

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                                <FiSlash size={16} /> Cancelar
                            </button>
                            <button type="submit" className="btn btn-outline-primary">
                                <FiSave size={16} /> Guardar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
